import React from 'react'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
// import './NumericAotuIncrement.scss'

const FromToWithDropdown = ({fieldType, onChange = (e, key, value, typeId) => {}, idx, data}) => {
  return (
    <Grid container spacing={2} className="numeric-auto-field">
      <Grid item xs={2}>
        <FormControl variant="outlined" className="ap-textfield" style={{width: '100%'}}>
          <InputLabel id="">In</InputLabel>
          <Select
            name="inout"
            defaultValue={
              data?.invert_query === true ? 'true' : data?.invert_query === false ? 'false' : ''
            }
            onChange={e =>
              onChange(
                e,
                'list_filters_attributes',
                e.target.value,
                'invert_query',
                idx,
                '',
                fieldType.id
              )
            }
            label="In"
          >
            <MenuItem value="false">In</MenuItem>
            <MenuItem value="true">Not In</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={10}>
        <Grid row xs={12}>
          <label style={{width: '13%', marginTop: '16px'}}>From:</label>
          <TextField
            id="outlined-basic"
            variant="outlined"
            className="ap-textfield"
            type="number"
            defaultValue={data?.min_value}
            style={{width: '85%'}}
            onChange={e =>
              onChange(
                e,
                'list_filters_attributes',
                e.target.value,
                'min_value',
                idx,
                '',
                fieldType.id
              )
            }
          />
        </Grid>
        <Grid row xs={12}>
          <label style={{width: '13%', marginTop: '16px'}}>To:</label>
          <TextField
            id="outlined-basic1"
            variant="outlined"
            className="ap-textfield"
            type="number"
            defaultValue={data?.max_value}
            style={{width: '85%'}}
            onChange={e =>
              onChange(
                e,
                'list_filters_attributes',
                e.target.value,
                'max_value',
                idx,
                '',
                fieldType.id
              )
            }
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
export default FromToWithDropdown
